<template>
  <nav
    :class="['zg-breadcrumb', {
      [`zg-breadcrumb--text-color-${textColor}`]: textColor
    }]"
  >
    <ul class="size--large">
      <li
        v-for="(breadCrumb, index) in breadCrumbs"
        :key="index"
      >
        <zg-icon
          v-if="breadCrumb.title && index > 0"
          icon="chevron"
          size="xsmall"
          rotate="270"
          :color="textColor"
        />

        <a
          v-if="breadCrumbs.length - 1 !== index"
          :href="breadCrumb.url"
        >
          {{ breadCrumb.title }}
        </a>

        <span v-else>
          {{ breadCrumb.title }}
        </span>
      </li>
    </ul>

    <ul
      v-if="breadCrumbs.length > 0"
      class="size--small"
    >
      <li>
        <zg-icon
          icon="arrow-back"
          size="xsmall"
          :color="textColor"
        />

        <a
          :href="smallDeviceLink && smallDeviceLink.url"
          v-html="smallDeviceLink && smallDeviceLink.title"
        />
      </li>
    </ul>
  </nav>
</template>
<script>
  import { ZgIcon } from '../ZgIcon'

  export default {
    name: 'ZgBreadCrumb',
    components: {
      ZgIcon
    },
    props: {
      breadCrumbs: {
        type: Array,
        required: true,
        default: () => [],
        validator (breadCrumbs) {
          return breadCrumbs.filter(breadCrumb => (breadCrumb.url && breadCrumb.title)).length === breadCrumbs.length
        }
      },
      textColor: {
        type: String,
        required: false,
        default: 'black',
        validator: value => ['black', 'white'].includes(value)
      }
    },
    computed: {
      smallDeviceLink () {
        return this.breadCrumbs.length > 1 ? this.breadCrumbs[this.breadCrumbs.length - 2] : this.breadCrumbs[0]
      }
    }
  }
</script>

<style lang="scss" scoped>
  nav {
    @include type-body-s;

    ul {
      list-style: none;
      margin: 0;
      padding: unset;
      flex-wrap: wrap;

      li {
        display: flex;
        align-items: center;
        font-weight: font-weight(bold);

        &:nth-last-child(1) {
          font-weight: font-weight(normal);
        }

        ::v-deep svg {
          margin: 0 rhythm(xsmall) 0 0;

          @include mq(medium) {
            margin: 0 rhythm(xsmall);
          }
        }
      }

      a {
        text-decoration: none;
        border-bottom: none;

        @include mq(medium) {
          font-weight: font-weight(bold);
        }
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // modifiers
  // ? ----------------------------------------------------------------------

  .size--small {
    display: flex;

    @include mq(medium) {
      display: none;
    }

    li:nth-last-child(1) {
      font-weight: font-weight(bold);
    }
  }

  .size--large {
    display: none;

    @include mq(medium) {
      display: flex;
    }
  }

  .zg-breadcrumb--text-color-black {
    *,
    a {
      color: color(black);
    }
  }

  .zg-breadcrumb--text-color-white {
    *,
    a {
      color: color(white);
    }
  }
</style>
